import React from 'react';

import { CheckButton, CheckButtonProps } from './check-button';

export type CheckBoxProps = Omit<CheckButtonProps, 'type'>;

export const CheckBox = (props: CheckBoxProps) => <CheckButton type="checkbox" {...props} />;

CheckBox.displayName = 'CheckBox';
